export const featuredArtworks = [
  {
    id: 1,
    title: 'Abstract Expressionism',
    artist: 'Maria Rodriguez',
    price: '$2,500',
    image: 'https://images.unsplash.com/photo-1547826039-bfc35e0f1ea8?w=1200&h=800&fit=crop&q=80',
    description: 'A vibrant exploration of color and form'
  },
  {
    id: 2,
    title: 'Urban Reflections',
    artist: 'James Wilson',
    price: '$3,200',
    image: 'https://images.unsplash.com/photo-1561214115-f2f134cc4912?w=1200&h=800&fit=crop&q=80',
    description: 'Contemporary cityscape in oil'
  },
  {
    id: 3,
    title: 'Nature\'s Symphony',
    artist: 'Sarah Chen',
    price: '$4,800',
    image: 'https://images.unsplash.com/photo-1549289524-06cf8837ace5?w=1200&h=800&fit=crop&q=80',
    description: 'Impressionist landscape masterpiece'
  },
  {
    id: 4,
    title: 'Modern Minimalism',
    artist: 'David Kim',
    price: '$1,900',
    image: 'https://images.unsplash.com/photo-1553775282-20af80779df7?w=1200&h=800&fit=crop&q=80',
    description: 'Clean lines and bold statements'
  },
  {
    id: 5,
    title: 'Cultural Fusion',
    artist: 'Aisha Patel',
    price: '$3,500',
    image: 'https://images.unsplash.com/photo-1578321272125-4e4c4c3643c5?w=1200&h=800&fit=crop&q=80',
    description: 'Traditional meets contemporary'
  }
];

export const heroBackground = 'https://images.unsplash.com/photo-1577083552431-6e5fd01aa342?w=1920&h=1080&fit=crop&q=80';

export const ctaBackground = 'https://images.unsplash.com/photo-1578926288207-a90a5366759d?w=1920&h=800&fit=crop&q=80'; 